import type { CountyStatePair, PipelineMapTapDenyReason } from '@buxus/shared'
import { PIPELINE_MAP_TAP_DENY_TITLE, pipelineMapTapDenyMessage } from '@buxus/shared'

function formatLocationLabel(geoPairs: readonly CountyStatePair[]): string | null {
  if (!geoPairs.length) return null
  return geoPairs.map((pair) => `${pair.county}, ${pair.state}`).join(' · ')
}

type MapPipelineJurisdictionDeniedBubbleProps = {
  reason: PipelineMapTapDenyReason
  geoPairs: readonly CountyStatePair[]
  showLocation: boolean
  onClose: () => void
}

export function MapPipelineJurisdictionDeniedBubble({
  reason,
  geoPairs,
  showLocation,
  onClose,
}: MapPipelineJurisdictionDeniedBubbleProps) {
  const location = showLocation ? formatLocationLabel(geoPairs) : null

  return (
    <div
      className="map-pipeline-popup map-pipeline-popup--jurisdiction-denied"
      role="dialog"
      aria-label="Pipeline segment unavailable"
    >
      <div className="map-pipeline-popup-content">
        <p className="map-pipeline-popup-restricted-lead">{PIPELINE_MAP_TAP_DENY_TITLE}</p>
        <p className="map-pipeline-popup-restricted-message">{pipelineMapTapDenyMessage(reason)}</p>
        {location ? (
          <p className="map-pipeline-popup-restricted-location">
            <span className="map-pipeline-popup-restricted-location-label">Area:</span> {location}
          </p>
        ) : null}
      </div>
      <div className="map-pipeline-popup-actions">
        <button type="button" className="map-pipeline-popup-btn primary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  )
}
